import { env } from '@gitbook/env';

const GB_TEST_FLAGS_SESSION_STORAGE_KEY = 'gitbook_test_flags';

declare global {
    interface Window {
        __gitbookTestFeatureFlagOverrides?: string[];
    }
}

/**
 * Return feature flag overrides from sessionStorage.
 *
 * This is for testing purposes and is only active in the test environment.
 * It allows to set feature flags in e2e tests.
 *
 * When flags are passed to the login function they are persisted to sessionStorage
 * before any app JavaScript runs.
 * Flags must be set in each test as tests run in different browser contexts, so flags set in one test won't leak to another test.
 */
export function getFeatureFlagTestOverrides(): string[] | undefined {
    if (env !== 'test') {
        return undefined;
    }

    let flags: string[] = [];

    try {
        const stored = sessionStorage.getItem(GB_TEST_FLAGS_SESSION_STORAGE_KEY);
        if (stored) {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) {
                flags = parsed.filter((flag): flag is string => typeof flag === 'string');
            }
        }
    } catch {
        // Ignore sessionStorage errors
    }

    window.__gitbookTestFeatureFlagOverrides = flags;
    return flags.length > 0 ? flags : undefined;
}
